/**
 * Returns a deep copy of the input
 *
 * The input must be JSON serializable.
 */
export default function deepCopy<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj));
}
